export function isPublicViewUrl(path?: string) {
  if (!path) {
    path = window.location.pathname
  }
  return path.startsWith('/public/')
}
